/**
 *  DonutChart script file
 **/
import * as echarts from 'echarts'

export default {
  name: 'DonutChart',
  mixins: [],
  components: {},
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.createChart()

    window.addEventListener('resize', this.clearChart, false)
  },
  computed: {},
  methods: {
    createChart () {
      if (!this.$refs.container) {
        return
      }

      // Create the echarts instance
      const myChart = echarts.init(this.$refs.container)
      myChart.setOption(this.chartData)
    }
  },
  watch: {
    chartData: {
      handler () {
        this.createChart()
      },
      deep: true
    }
  }
}
